import * as Device from 'expo-device';
import * as Notifications from 'expo-notifications';
import Constants from 'expo-constants';
import { Platform } from 'react-native';
import { clientLogger } from './datadog';

if (Platform.OS !== 'web') {
  Notifications.setNotificationHandler({
    handleNotification: async () => ({
      shouldShowAlert: true,
      shouldPlaySound: true,
      shouldSetBadge: false,
      shouldShowBanner: true,
      shouldShowList: true,
    }),
  });
}

export async function registerForPushNotificationsAsync(): Promise<string | undefined> {
  clientLogger.info('[Push] Starting registration');
  if (Platform.OS === 'web') {
    clientLogger.info('[Push] Web platform detected - skipping push registration');
    return undefined;
  }
  if (Platform.OS === 'android') {
    await Notifications.setNotificationChannelAsync('default', {
      name: 'default',
      importance: Notifications.AndroidImportance.MAX,
      vibrationPattern: [0, 250, 250, 250],
      lightColor: '#FF231F7C',
    });
  }

  if (Device.isDevice) {
    const { status: existingStatus } = await Notifications.getPermissionsAsync();
    clientLogger.info('[Push] Existing permission status', { existingStatus });
    let finalStatus = existingStatus;
    if (existingStatus !== 'granted') {
      const { status } = await Notifications.requestPermissionsAsync();
      finalStatus = status;
      clientLogger.info('[Push] New permission status', { finalStatus });
    }
    if (finalStatus !== 'granted') {
      clientLogger.warn('[Push] Permission not granted');
      return undefined;
    }
    
    const projectId =
      Constants?.expoConfig?.extra?.eas?.projectId ?? Constants?.easConfig?.projectId;
    clientLogger.info('[Push] Project ID resolved', { hasProjectId: Boolean(projectId) });
      
    try {
      const pushTokenString = (
        await Notifications.getExpoPushTokenAsync({
          projectId,
        })
      ).data;
      clientLogger.info('[Push] Token obtained');
      return pushTokenString;
    } catch (error) {
      clientLogger.error('[Push] Error getting token', {
        error: error instanceof Error ? error.message : String(error),
      });
      return undefined;
    }
  } else {
    clientLogger.info('[Push] Not a physical device - skipping push registration');
    return undefined;
  }
}
